{
  "steplist": "Zoznam krokov"
}
